import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { TabItem } from 'features/divisions';

type TDivisionsSliceState = {
  currentOption: TabItem | null;
};

const initialState: TDivisionsSliceState = {
  currentOption: null,
};

export const divisionsSlice = createSlice({
  name: 'divisions',
  initialState,
  reducers: {
    setCurrentOption: (state, { payload }: PayloadAction<TabItem | null>) => {
      state.currentOption = payload;
    },
  },
});

const currentDivision = (state: RootState) => state.entities.divisions;
export const getCurrentDivision = createSelector(currentDivision, state => state);

export const { setCurrentOption } = divisionsSlice.actions;
export const reducer = divisionsSlice.reducer;
